import ReactRenderer from "modules/_react-renderer";

import ProductForm from 'app/React/ProductForm'
import ProductSlider from 'app/React/ProductSlider'
import InspirationUniverse from 'app/React/InspirationUniverse'

ReactRenderer.registerComponent('ProductForm', ProductForm)
ReactRenderer.registerComponent('ProductSlider', ProductSlider)
ReactRenderer.registerComponent('InspirationUniverse', InspirationUniverse)

ReactRenderer.render();
